<div class="icon-wrapper" [class.flipVertical]="flipVertical" [class.active]="active">
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5">
    <path id="Polígono_32" data-name="Polígono 32"
      d="M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z"
      transform="translate(10 5) rotate(180)" [attr.fill]="mainColor" />
  </svg>
</div>